import React, {useMemo, useState} from "react";

//customHook
import useMinimizar from '../../customHooks/useMinimizar';

import RRDocumento from "../renderRows/RRDocumento";

import ModalForm from "../modalForm/ModalForm";

import './DocumentosList.css';
import normalizeText from "../../utils/normalizeText";

const DocumentosList = ({docsList,filter,docFilesMap}) =>{
    
    const {indexToEdit,setIndexToEdit,formToShow,setFormToShow,minimizar} = useMinimizar();

    let docsFiltrados = useMemo(()=> docsList.filter(d => {
        return filter != '' ?
            (filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"') ?
                (normalizeText(d.codActivo) == normalizeText(filter.replaceAll('"','')) || normalizeText(d.codDocumento) == normalizeText(filter.replaceAll('"','')) || normalizeText(d.nameActivo) == normalizeText(filter.replaceAll('"','')) || normalizeText(d.nameDocumento) == normalizeText(filter.replaceAll('"','')))
                :
                (normalizeText(d.codActivo).includes(normalizeText(filter)) || normalizeText(d.codDocumento).includes(normalizeText(filter)) || normalizeText(d.nameActivo).includes(normalizeText(filter)) || normalizeText(d.nameDocumento).includes(normalizeText(filter)))
        : true
    }),[docsList, filter])

    return <div className="docsListDiv">
        {docsFiltrados.map((d,i) => <RRDocumento doc={d} index={i} key={i} setIndexToEdit={setIndexToEdit} setFormToShow={setFormToShow} archivoDoc={docFilesMap[`${d.codActivo}-${d.codDocumento}`]}/>)}
        {(indexToEdit != -1) && <ModalForm docToEdit={docsList[indexToEdit]} componentePadre={'Documentos'} formToShow={formToShow} minimizar={minimizar}/>}
    </div>

}

export default DocumentosList;